var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('modal',{scopedSlots:_vm._u([{key:"headline",fn:function(){return [_vm._v("\n      "+_vm._s(_vm.$t('web_ie_modal_title'))+"\n    ")]},proxy:true}])},[_c('p',[_vm._v(_vm._s(_vm.$t('web_ie_modal_message')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }